/** Official Grant & RFP Navigator lockup.
 *  variant="white" for dark surfaces (auth gradient panel, nav rail),
 *  variant="color" for light surfaces (marketing nav/footer, white topbars).
 *  Served as static <img> files so the SVGs' internal class names can never
 *  collide with page CSS.
 */
export default function BrandLogo({
  variant,
  height = 40,
  className,
}: {
  variant: 'white' | 'color';
  height?: number;
  className?: string;
}) {
  return (
    <img
      src={variant === 'white' ? '/brand-white.svg' : '/brand-color.svg'}
      alt="The Grant & RFP Navigator"
      height={height}
      className={className ?? 'brand-logo'}
      draggable={false}
    />
  );
}
